(() => {
  const header = document.querySelector('[data-header]');
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuClose = document.querySelector('[data-menu-close]');
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const searchOpen = document.querySelector('[data-search-open]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchDialog = document.querySelector('[data-search-dialog]');
  const searchInput = searchDialog?.querySelector('input[type="search"]');
  const sortSelect = document.querySelector('[data-sort-by]');
  const backgroundVideos = document.querySelectorAll(
    '.hero-campaign__video, .password-gate__video, .collection-split__video, .collection-hero__video'
  );

  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const setMenuExpanded = (open) => {
    menuOpen?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const openMenu = () => {
    if (!menuDrawer || menuDrawer.open) return;
    menuDrawer.showModal();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => menuDrawer.classList.add('is-open'));
    });
    setMenuExpanded(true);
  };

  const closeMenu = () => {
    if (!menuDrawer?.open) return;
    menuDrawer.classList.remove('is-open');
    setMenuExpanded(false);
    const finish = () => {
      if (menuDrawer.open) menuDrawer.close();
    };
    const onEnd = (event) => {
      if (event.target !== menuDrawer || event.propertyName !== 'transform') return;
      menuDrawer.removeEventListener('transitionend', onEnd);
      finish();
    };
    menuDrawer.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 480);
  };

  menuOpen?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuDrawer?.addEventListener('click', (event) => {
    if (event.target === menuDrawer) closeMenu();
  });
  menuDrawer?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeMenu();
  });

  menuDrawer?.querySelectorAll('[data-menu-folder]').forEach((button) => {
    button.addEventListener('click', () => {
      const folder = button.closest('.site-drawer__folder');
      if (!folder) return;
      const willOpen = !folder.classList.contains('is-open');
      menuDrawer.querySelectorAll('.site-drawer__folder').forEach((other) => {
        other.classList.remove('is-open');
        other.querySelector('[data-menu-folder]')?.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        folder.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  searchOpen?.addEventListener('click', () => {
    searchDialog?.showModal();
    searchInput?.focus();
  });
  searchClose?.addEventListener('click', () => searchDialog?.close());
  searchDialog?.addEventListener('click', (event) => {
    if (event.target === searchDialog) searchDialog.close();
  });

  backgroundVideos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
  });

  if (backgroundVideos.length) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const playVideo = (video) => video.play().catch(() => {});

    if (reduceMotion) {
      backgroundVideos.forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
      });
    } else if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) playVideo(entry.target);
            else entry.target.pause();
          });
        },
        { rootMargin: '160px 0px', threshold: 0.2 }
      );
      backgroundVideos.forEach((video) => observer.observe(video));
    } else {
      backgroundVideos.forEach(playVideo);
    }
  }

  if (sortSelect) {
    const params = new URLSearchParams(window.location.search);
    sortSelect.addEventListener('change', (event) => {
      params.set('sort_by', event.target.value);
      window.location.search = params.toString();
    });
  }

  const gallery = document.querySelector('[data-product-gallery]');
  const mainImage = gallery?.querySelector('.product-main__image');
  const thumbs = gallery?.querySelectorAll('[data-gallery-thumb]') || [];

  const showImage = ({ src, srcset, width, height, alt }) => {
    if (!mainImage || !src) return;
    mainImage.src = src;
    if (srcset) mainImage.srcset = srcset;
    if (width) mainImage.width = width;
    if (height) mainImage.height = height;
    if (alt) mainImage.alt = alt;
  };

  if (gallery) {
    thumbs.forEach((thumb) => {
      const activate = () => {
        showImage({
          src: thumb.dataset.src,
          srcset: thumb.dataset.srcset,
          width: thumb.dataset.width,
          height: thumb.dataset.height,
          alt: thumb.dataset.alt,
        });
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };
      thumb.addEventListener('mouseenter', activate);
      thumb.addEventListener('focus', activate);
      thumb.addEventListener('click', activate);
    });
  }

  const productForm = document.querySelector('.product-form');
  if (productForm) {
    const jsonEl = productForm.querySelector('[data-product-json]');
    const variantInput = productForm.querySelector('[data-product-variant-id]');
    const submit = productForm.querySelector('[data-product-submit]');
    const priceRoot = document.querySelector('[data-product-price]');
    const priceValue = document.querySelector('[data-product-price-value]');
    const radios = productForm.querySelectorAll('[data-option-position]');
    let productData = { variants: [] };

    try {
      productData = JSON.parse(jsonEl?.textContent || '{"variants":[]}');
    } catch {
      productData = { variants: [] };
    }

    const selectedOptions = () => {
      const values = [];
      radios.forEach((radio) => {
        if (!radio.checked) return;
        values[Number(radio.dataset.optionPosition) - 1] = radio.value;
      });
      return values;
    };

    const findVariant = (options) =>
      productData.variants.find((variant) =>
        variant.options.every((value, index) => value === options[index])
      );

    const updateSwatches = (options) => {
      radios.forEach((radio) => {
        const position = Number(radio.dataset.optionPosition);
        const available = productData.variants.some((variant) => {
          if (variant.options[position - 1] !== radio.value) return false;
          return variant.options.every((value, index) => index === position - 1 || value === options[index]);
        });
        const inStock = productData.variants.some((variant) => {
          if (!variant.available || variant.options[position - 1] !== radio.value) return false;
          return variant.options.every((value, index) => index === position - 1 || value === options[index]);
        });
        radio.disabled = !available;
        radio.nextElementSibling?.classList.toggle('is-unavailable', available && !inStock);
      });
    };

    const updatePrice = (variant) => {
      if (!priceValue || !variant) return;
      priceValue.textContent = variant.price;
      const compare = priceRoot?.querySelector('[data-product-compare]');
      if (compare) {
        compare.hidden = !variant.compare_at_price;
        if (variant.compare_at_price) compare.textContent = variant.compare_at_price;
      }
      const off = priceRoot?.querySelector('[data-product-off]');
      if (off) {
        off.hidden = !variant.discount_label;
        if (variant.discount_label) off.textContent = variant.discount_label;
      }
    };

    const syncVariant = () => {
      const options = selectedOptions();
      const variant = findVariant(options);
      updateSwatches(options);
      if (!variant) {
        if (submit) submit.disabled = true;
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (submit) submit.disabled = !variant.available;
      updatePrice(variant);
      if (variant.image) showImage(variant.image);
    };

    radios.forEach((radio) => radio.addEventListener('change', syncVariant));
    syncVariant();
  }

  const relatedRoot = document.querySelector('[data-related-products]');
  if (relatedRoot && !relatedRoot.querySelector('.related-products__grid') && relatedRoot.dataset.url) {
    const loadRelated = () => {
      fetch(relatedRoot.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const next = html.querySelector('[data-related-products]');
          if (next?.querySelector('.related-products__grid')) {
            relatedRoot.replaceWith(next);
          }
        })
        .catch(() => {});
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        loadRelated();
      }, { rootMargin: '0px 0px 240px 0px' });
      observer.observe(relatedRoot);
    } else {
      loadRelated();
    }
  }

  const qty = document.querySelector('[data-product-qty]');
  if (qty) {
    const input = qty.querySelector('.product-qty__input');
    const minus = qty.querySelector('[data-qty-minus]');
    const plus = qty.querySelector('[data-qty-plus]');

    const syncQty = () => {
      const value = Math.max(1, Number(input?.value) || 1);
      if (input) input.value = String(value);
      if (minus) minus.disabled = value <= 1;
    };

    minus?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Math.max(1, Number(input.value || 1) - 1));
      syncQty();
    });
    plus?.addEventListener('click', () => {
      if (!input) return;
      input.value = String(Math.max(1, Number(input.value || 1) + 1));
      syncQty();
    });
    input?.addEventListener('change', syncQty);
    syncQty();
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const routesRoot = window.Shopify?.routes?.root || '/';

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = Number(count) < 1;
    });
  };

  const replaceCartDrawer = (html) => {
    if (!html || !cartDrawer) return;
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const next = wrap.querySelector('[data-cart-drawer]');
    if (!next) return;
    cartDrawer.innerHTML = next.innerHTML;
  };

  const openCart = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.open) return;
    drawer.showModal();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => drawer.classList.add('is-open'));
    });
  };

  const closeCart = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer?.open) return;
    drawer.classList.remove('is-open');
    const finish = () => {
      if (drawer.open) drawer.close();
    };
    const onEnd = (event) => {
      if (event.target !== drawer || event.propertyName !== 'transform') return;
      drawer.removeEventListener('transitionend', onEnd);
      finish();
    };
    drawer.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 480);
  };

  const cartRequest = (url, payload) =>
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).then((response) => response.json());

  const sectionId = cartDrawer?.dataset.sectionId;

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-cart-open]');
    if (openTrigger) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (!change) return;
    event.preventDefault();
    cartRequest(`${routesRoot}cart/change.js`, {
      id: change.dataset.key,
      quantity: Number(change.dataset.qty),
      sections: sectionId,
    }).then((data) => {
      if (data.sections?.[sectionId]) replaceCartDrawer(data.sections[sectionId]);
      if (typeof data.item_count === 'number') updateCartCount(data.item_count);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  });

  cartDrawer?.addEventListener('click', (event) => {
    if (event.target === cartDrawer) closeCart();
  });
  cartDrawer?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeCart();
  });

  productForm?.addEventListener('submit', (event) => {
    if (!cartDrawer) return;
    event.preventDefault();
    const formData = new FormData(productForm);
    const id = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);
    cartRequest(`${routesRoot}cart/add.js`, {
      id,
      quantity,
      sections: sectionId,
    }).then((data) => {
      if (data.status && data.message) return;
      if (data.sections?.[sectionId]) replaceCartDrawer(data.sections[sectionId]);
      fetch(`${routesRoot}cart.js`)
        .then((response) => response.json())
        .then((cart) => updateCartCount(cart.item_count));
      openCart();
    });
  });

  const closeLocalizationPickers = (except) => {
    document.querySelectorAll('[data-localization-picker]').forEach((picker) => {
      if (picker === except) return;
      picker.querySelector('[data-localization-toggle]')?.setAttribute('aria-expanded', 'false');
      picker.querySelector('[data-localization-panel]')?.setAttribute('hidden', '');
    });
  };

  document.querySelectorAll('[data-localization-picker]').forEach((picker) => {
    const toggle = picker.querySelector('[data-localization-toggle]');
    const panel = picker.querySelector('[data-localization-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      closeLocalizationPickers(willOpen ? picker : null);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      panel.toggleAttribute('hidden', !willOpen);
    });
  });

  document.querySelectorAll('button[name="locale_code"]').forEach((button) => {
    button.addEventListener('click', () => {
      try {
        localStorage.setItem('regalia-locale', button.value);
      } catch (error) {}
    });
  });

  document.addEventListener('click', () => closeLocalizationPickers());
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLocalizationPickers();
  });
})();
